var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "humbleicons:user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.5686 52.33V48.7291C49.5686 42.7631 44.0405 37.9264 37.2218 37.9264H27.3467C20.5281 37.9264 15 42.7631 15 48.7291V52.33M40.9264 20.6421C40.9264 22.9342 40.0159 25.1323 38.3952 26.7531C36.7745 28.3738 34.5763 29.2843 32.2843 29.2843C29.9922 29.2843 27.7941 28.3738 26.1734 26.7531C24.5526 25.1323 23.6421 22.9342 23.6421 20.6421C23.6421 18.3501 24.5526 16.1519 26.1734 14.5312C27.7941 12.9105 29.9922 12 32.2843 12C34.5763 12 36.7745 12.9105 38.3952 14.5312C40.0159 16.1519 40.9264 18.3501 40.9264 20.6421Z",
    stroke: "#00945E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.a88fbc5cd8a1f9af782fa7bae532410b.svg";
export { ForwardRef as ReactComponent };